import React, { useState, useEffect } from 'react';
import axios from 'axios';

/* istanbul ignore next -- REACT_APP_BACKEND_URL is inlined at build time */
const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const ColorRecommendationDisplay = ({ color, brands, inventoryOnly = false, token, inventoryVersion = 0 }) => {
  const [recommendation, setRecommendation] = useState('');

  useEffect(() => {
    const getRecommendation = async () => {
      if (color && (inventoryOnly ? token : brands && brands.length > 0)) {
        try {
          const response = await axios.get(
            `${API_URL}/api/color-recommendations/${color.replace('#', '')}`,
            {
              params: inventoryOnly
                ? { inventory_only: true }
                : { brand: brands.join(',') },
              headers: inventoryOnly ? { Authorization: `Bearer ${token}` } : {}
            }
          );
          if (response.data.recommendations) {
            setRecommendation(response.data.recommendations.map((r) => r.recommendation).join(' / '));
          } else {
            setRecommendation(response.data.recommendation);
          }
        } catch (error) {
          setRecommendation('Color match unavailable');
        }
      }
    };

    getRecommendation();
  }, [color, brands, inventoryOnly, token, inventoryVersion]);

  return <span className="text-xs">{recommendation}</span>;
};

export default ColorRecommendationDisplay;
